export default theme => ({
  avatar: {
    margin: theme.spacing.unit,
    width: 25,
    height: 25
  }
});
